module.exports = __webpack_public_path__ + "img/cloudplatform_2.471de196.png";